import HasID from "./HasID";
import {EscriptResponse} from "./Escript";

export interface QueueItem extends HasID {
    imageID: number;
    escriptID: number;
    programTransferId: number;
    imageType: string;
    storeID: number;
    rxNumber: number;
    rfNumber: number;
    // Null on both columns means Unsorted — either never routed, or explicitly moved there.
    bucketType: number | null;
    bucket: number | null;
    source: string;
    ingested: Date;
    completed: Date;
    completedBy: string;
    escriptResponse: EscriptResponse;
    imgSrc: string;
    imageUrl?: string;  // URL path for lazy loading images
    escriptMessageType: string;
    escriptMessageKind: string;
    patientId?: number | null;
    quantityPrescribed?: number | null;
    quantityDispensed?: number | null;
}

// Wire values used by POST IngestionQueue/Route (match the backend QueueItem.BucketTypeEnum):
// static/custom buckets are 0, program buckets are 1.
export enum BucketType {
    Static = 0,
    Program = 1
}
